export const SUBSCRIPTION_STATUS = {
    ACTIVE: 1,
    OVERDUE: 2,
    CANCEL_PENDING: 3,
} as const;

export const STATUS_LABEL: Record<number, string> = {
    [SUBSCRIPTION_STATUS.ACTIVE]: 'Active',
    [SUBSCRIPTION_STATUS.CANCEL_PENDING]: 'Cancel Pending',
    [SUBSCRIPTION_STATUS.OVERDUE]: 'Overdue',
};
